import { MainComponent } from "../components";
import { connect } from "react-redux";
import { GetDataMainMenuAuthorizationAction, SetDataMainMenuAuthorizationAction,GetDataUserAction,
    SetDataPermissionnAction
} from "../actions";

const mapStateToProps = state => {
    return {
        ...state,
        DataMain: state.allMenuAuthorizationReducers.mainALLReducer.mainReducer.DataMain,
        DataUser: state.allMenuAuthorizationReducers.mainALLReducer.GetuserReducer.DataUser,
        isResult: state.allMenuAuthorizationReducers.isResultReducer.isResult
    };
};

const mapDispatchToProps = dispatch => {
    return {
        //getdata menu
        GetDataMain: () => {
            dispatch(GetDataMainMenuAuthorizationAction());
        },
        SetDataMain: (DataMain) => {
            dispatch(SetDataMainMenuAuthorizationAction(DataMain));
        },
        //getdata user
        GetDataUser: () => {
            dispatch(GetDataUserAction());
        },
        //Set quyền
        SetDataPermission: (DataMain) => {
            dispatch(SetDataPermissionnAction(DataMain));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainComponent);